var win; // Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.

try {
  win = window;
} catch (e) {}
/* no-op */

/**
 * Helper to get the window object. The helper will make sure to use a cached variable
 * of "window", to avoid overhead and memory leaks in IE11.
 */


var getWindow = function getWindow(node) {
  var _node$ownerDocument$d, _node$ownerDocument;

  return (_node$ownerDocument$d = node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) != null ? _node$ownerDocument$d : win;
};
/**
 * Check if we can use the DOM. Useful for SSR purposes
 */

function checkIsBrowser() {
  var w = getWindow();
  return Boolean(typeof w !== 'undefined' && w.document && typeof w.document.createElement === 'function');
}

var isBrowser = /*#__PURE__*/checkIsBrowser();
/**
 * Get the normalized event key across all browsers
 * @param event keyboard event
 */

function normalizeEventKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  var isArrowKey = keyCode >= 37 && keyCode <= 40 && !key.startsWith('Arrow');
  return isArrowKey ? "Arrow" + key : key;
}
var dataAttr = function dataAttr(condition) {
  return condition ? '' : undefined;
};
var getOwnerDocument = function getOwnerDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
};
function getEventWindow(event) {
  var _event$view;

  return (_event$view = event.view) != null ? _event$view : window;
}
function isElement(el) {
  return el != null && typeof el === 'object' && 'nodeType' in el && el.nodeType === Node.ELEMENT_NODE;
}
function isHTMLElement(el) {
  var _el$ownerDocument$def;

  if (!isElement(el)) {
    return false;
  }

  var defaultView = (_el$ownerDocument$def = el.ownerDocument.defaultView) != null ? _el$ownerDocument$def : window;
  return el instanceof defaultView.HTMLElement;
}
function contains(parent, child) {
  if (!parent) return false;
  return parent === child || parent.contains(child);
}
function getActiveElement(node) {
  var doc = getOwnerDocument(node);
  return doc == null ? void 0 : doc.activeElement;
}
function getRelatedTarget(event) {
  var _event$target, _event$relatedTarget;

  var target = (_event$target = event.target) != null ? _event$target : event.currentTarget;
  var activeElement = getActiveElement(target);
  return (_event$relatedTarget = event.relatedTarget) != null ? _event$relatedTarget : activeElement;
}

export { contains, dataAttr, getActiveElement, getEventWindow, getOwnerDocument, getRelatedTarget, getWindow, isBrowser, isElement, isHTMLElement, normalizeEventKey };
//# sourceMappingURL=dom.esm.js.map
